export function getDimensionLabelSizing(scale: number) {
  const safeScale = Math.max(scale || 1, 0.01);

  return {
    fontSize: Math.min(12 / safeScale, 22),
    smallOffset: Math.min(8 / safeScale, 18),
    offset: Math.min(16 / safeScale, 28),
  };
}
